"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentFilenamePrefix = void 0;
var DocumentFilenamePrefix;
(function (DocumentFilenamePrefix) {
    DocumentFilenamePrefix["POLICY_PDF"] = "policyPDF";
    DocumentFilenamePrefix["APPLICATION_PDF"] = "applicationPDF";
    DocumentFilenamePrefix["PREISSUANCE_PDF"] = "preissuancePDF";
    DocumentFilenamePrefix["FAMILY_APPLICATION_PDF"] = "familyApplicationPDF";
    DocumentFilenamePrefix["POLICY_JSON"] = "policyJSON";
})(DocumentFilenamePrefix = exports.DocumentFilenamePrefix || (exports.DocumentFilenamePrefix = {}));
